export const sideOptions = [
	{ label: 'Both', value: 'Both' },
	{ label: 'Left', value: 'Left' },
	{ label: 'Right', value: 'Right' },
	{ label: 'Middle', value: 'Middle' },
];
